<template>
  <div>
  <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <!-- <div class="container-fluid pb-3">
          <div class="row">
            <div class="col-sm-12">
              <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                 <div class="col-md-6 pt-4">
                  <h2 class="naranja">¡Hola Juan!</h2>
                  <h2>¿Qué necesitas hacer?</h2>
                </div>

                <div class="col-md-6 pt-4">
                  <div class="float-md-right">
                    <div class="status">
                      <div>
                        <i class="far fa-check-circle fa-2x"></i>
                      </div>
                      <div>
                        <div>Contrato activo</div>
                        <div>Vigencia: 20 de marzo de 2020</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo">
                    <router-link to="/dashboard/alumnos">Alumnos</router-link>
                    <i class="fa fa-chevron-right"></i> Actualización de datos
                  </span>
                </div>
                <div class="col-6 col-md-6">
                  <router-link class="btnblanco float-right"
                  to="/dashboard/alumnos/alta">
                    Nuevo alumno
                    <i class="fa fa-plus-circle"></i>
                  </router-link>
                </div>
              </div>

              <div class="contenido">
                <div class="row">
                  <div class="col-12 col-md-6 pb-3">
                    <div class="formulario col-12 bggris rounded pt-5 pb-4 card">
                      <h2 class="text-center mb-3 pb-2">Actualización de datos</h2>
                      <form method="post" @submit="submitFormulario($event)">
                        <label>
                          <span>Matrícula:</span>
                          <input
                            type="text"
                            v-model="form.matricula"
                            maxlength="100"
                            placeholder="Matrícula"
                            required
                            disabled
                          />
                        </label>

                        <label>
                          <span>Nombre(s):</span>
                          <input
                            type="text"
                            v-model="form.nombre"
                            maxlength="100"
                            placeholder="Nombre(s)"
                            required
                          />
                        </label>

                        <label>
                          <span>Apellido paterno:</span>
                          <input
                            type="text"
                            v-model="form.apaterno"
                            maxlength="100"
                            placeholder="Apellido paterno"
                            required
                          />
                        </label>

                        <label>
                          <span>Apellido materno:</span>
                          <input
                            type="text"
                            v-model="form.amaterno"
                            maxlength="100"
                            placeholder="Apellido materno"
                            required
                          />
                        </label>

                        <label>
                          <span>Email:</span>
                          <input
                            type="email"
                            v-model="form.email"
                            maxlength="100"
                            placeholder="Email"
                            required
                          />
                        </label>

                        <div class="text-center pt-2">
                          <button type="submit" class="submit btnblanco">Actualizar datos</button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 pb-3">
                    <div class="formulario col-12 bggris rounded pt-5 pb-4 card">
                      <h2 class="text-center mb-3 pb-2">Reestablecimiento de contraseña</h2>
                      <form method="post" @submit="submitFormulario2($event)">
                        <label class>
                          <input
                            type="password"
                            v-model="form2.pwd"
                            maxlength="100"
                            placeholder="Contraseña"
                            required
                          />
                        </label>

                        <label class>
                          <input
                            type="password"
                            v-model="form2.pwd2"
                            maxlength="100"
                            placeholder="Repetir contraseña"
                            required
                          />
                        </label>

                        <div class="text-center pt-2">
                          <button type="submit" class="submit btnblanco">Reestablecer contraseña</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <span class="loading" v-bind:class="{active: this.$store.state.loading}">
                  <img src="../../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Menu from "../../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      form: {
        matricula: "",
        nombre: "",
        apaterno: "",
        amaterno: "",
        email: ""
      },
      form2: {
        matricula: "",
        pwd: "",
        pwd2: ""
      },

      columns: [
        "matricula",
        "nombre",
        "user_email",
        "grupos",
        "uri",
        "baja",
        "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Matrícula",
          nombre: "Nombre",
          user_email: "Email",
          grupos: "Grupos",
          uri: "Actualización de datos",
          baja: "Baja",
          bloqueo: "Bloqueo"
        },
        editableColumns: ["name"],
        sortable: ["nombre"],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Búsqueda",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      }
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu
  },
  mounted: function() {
  this.$store.state.user = JSON.parse(this.$cookie.get('useriee'));
    AOS.init();

    this.form.matricula = this.$route.params.matricula;
    this.form2.matricula = this.$route.params.matricula;
    this.consulta();
  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        matricula: this.form.matricula
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "alumnos/consulta-actualizacion-alumno.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.form.nombre = res.datos[0].nombre;
              this.form.apaterno = res.datos[0].apellido_paterno;
              this.form.amaterno = res.datos[0].apellido_materno;
              this.form.email = res.datos[0].user_email;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        form: this.form
      };

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(qData));
      //formData.append("cv", this.file);

      console.log("enviando");
      //console.log(this.file);
      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "alumnos/actualizacion-alumno.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitFormulario2(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      if (this.form2.pwd.length >= 8) {
        if (this.form2.pwd == this.form2.pwd2) {
          const https = require("https");
          vm.$store.state.loading = true;

          var qData = {
            form: this.form2
          };

          let formData = new FormData();

          formData.append("form_data", JSON.stringify(qData));
          //formData.append("cv", this.file);

          console.log("enviando");
          //console.log(this.file);
          console.log(JSON.stringify(qData));

          this.$http
            .post(
              vm.$store.state.baseurl + "alumnos/cambio-contrasena-alumno.php",
              formData,
              {
                emulateJSON: true,
                httpsAgent: new https.Agent({ rejectUnauthorized: false }),
                headers: {
                  "Content-Type": "multipart/form-data"
                  //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
                }
              }
            )
            .then(
              response => {
                // get body data
                console.log("envio");
                console.log(response);
                vm.$store.state.loading = false;
                console.log(response.data);
                var res = response.data;

                if (res.status == "ok") {
                  swal.fire("Bien", res.msg, "success");
                  this.form2.pwd = "";
                  this.form2.pwd2 = "";
                } else if (res.status == "notok") {
                  swal.fire("Oops", res.msg, "warning");
                }
              },
              error => {
                // error callback
                console.log("error callback");
                console.log(error);
                vm.$store.state.loading = false;
                const mensaje =
                  error && error.body && error.body.msg
                    ? error.body.msg
                    : "Ha ocurrido un error, por favor intenta de nuevo.";
                swal.fire(
                  "Oops",
                  mensaje,
                  "warning"
                );
              }
            );
        } else {
          swal.fire("Oops", "Las contraseñas no coinciden.", "warning");
        }
      } else {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 caracteres.",
          "warning"
        );
      }
    }
  }
};
</script>

